export default __webpack_public_path__ + "static/media/arrowsSVG.49510392.svg";